import styled from "styled-components"
import { MediaQuery } from "../../../utils/design-helpers"

const CardGrid = styled.div`
  display: grid;
  grid-gap: 3rem;
  grid-template-columns: repeat(2, 1fr);

  ${MediaQuery.MD} {
    grid-template-columns: repeat(1, 1fr);
  }
`

export default CardGrid
